import { cn } from "@/lib/cn";

interface HtmlPreviewProps {
  html: string;
  className?: string;
}

export function HtmlPreview({ html, className }: HtmlPreviewProps) {
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none bg-white text-gray-900 rounded-md p-4 [&_p]:my-2 [&_ul]:my-2 [&_ol]:my-2 [&_li]:my-0.5",
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
